module.exports = __webpack_public_path__ + "img/eduID-white.2a59cb53.svg";